import React, { Component } from 'react'
import PropTypes from 'prop-types'

const base64TransparentImage =
    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAVIAAAD5CAQAAADfcHX9AAAB1klEQVR42u3SAQ0AAAzCsOPf9G0Q0kpYloNykQCTgkkxKZgUTIpJwaSYFEwKJsWkYFIwKSYFk2JSMCmYFJOCScGkmBRMiknBpGBSTAomBZNiUjApJgWTgkkxKZgUTIpJwaSYFEwKJsWkYFIwKSYFk2JSMCmYFJOCScGkmBRMiknBpGBSTAomBZNiUjApJgWTgkkxKZgUTIpJwaSYFEwKJsWkYFIwKSYFk2JSMCmYFJOCScGkmBRMiknBpGBSTAomBZNiUjApJgWTgkkxKZgUTIpJwaSYFEwKJsWkYFIwKSYFk2JSMCmYFJOCScGkmBRMiknBpGBSTAomBZNiUjApJgWTgkkxKZgUk4JJwaSYFEwKJsWkYFJMCiYFk2JSMCmYFJOCSTEpmBRMiknBpGBSTAomxaRgUjApJgWTgkkxKZgUk4JJwaSYFEwKJsWkYFJMCiYFk2JSMCmYFJOCSTEpmBRMiknBpGBSTAomxaRgUjApJgWTgkkxKZgUk4JJwaSYFEwKJsWkYFJMCiYFk2JSMCmYFJOCSTEpmBRMiknBpGBSTAomxaRgUjApJgWTgkkxKZgUk4JJwaSYFEwKJsWkYFJMCiYFk2JSMCmYFJOCSTEpmBRMyoAHLIIA+uoC5TcAAAAASUVORK5CYII='

class PlaceholderImage extends Component {
    constructor(props) {
        super(props)

        this.state = { loaded: false }
    }

    setLoaded = () => {
        this.setState({ loaded: true })
    }

    render() {
        const imgProps = {
            style: {
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                width: '100%',
            },
            onLoad: () => this.setLoaded(),
        }
        if (this.props.empty) {
            imgProps.src = base64TransparentImage
            imgProps.style.cursor = 'default'
        } else {
            imgProps.src = this.props.src
            imgProps.key = this.props.id
            imgProps.onClick = () => this.props.onClick()
        }
        return (
            <div style={{ position: 'relative', width: '100%', height: '100%' }}>
                <img alt="" aria-hidden {...imgProps} />
                <img style={{ opacity: !this.state.loaded }} src={base64TransparentImage} alt="" />
            </div>
        )
    }
}

PlaceholderImage.propTypes = {
    id: PropTypes.string,
    src: PropTypes.string,
    onClick: PropTypes.func,
    empty: PropTypes.bool,
}

export default PlaceholderImage



// WEBPACK FOOTER //
// ./src/features/Creatives/components/Feed/components/Viewer/components/PlaceholderImage/index.js